import moment from "moment";

const Footer = () => {
  return (
    <>
      <footer className="sticky-footer bg-white">
        <div className="container my-auto">
          <div className="copyright text-center my-auto">
            <span>&copy; {moment().format('YYYY')} Cubet. All Rights Reserved.</span>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
